import { EventConfigData } from 'src/app/@data-services/event-config/event-config.data-model';
import { resolveFullHubTitle } from './content-hub-name';

export const applyDocumentTitle = (
  config: EventConfigData,
  showRozieFavicon: boolean = true
): void => {
  window.document.title = resolveFullHubTitle(config);

  const faviconEl = document.querySelector(
    'link[rel="icon"]'
  ) as HTMLLinkElement | null;
  if (faviconEl) {
    if (!showRozieFavicon) {
      if (!faviconEl.dataset['originalHref']) {
        faviconEl.dataset['originalHref'] = faviconEl.href;
      }
      faviconEl.href = 'data:,';
    } else if (faviconEl.dataset['originalHref']) {
      faviconEl.href = faviconEl.dataset['originalHref'];
    }
  }
};
